export default "__VITE_ASSET__c0n6L_VP__"